module.exports = __webpack_public_path__ + "media/tier-4-xxxmas-5eec847afb1cb2cb0a5b1e9f8680dc2a.mp3";